const STATIONS = [
	'서울',
	'영등포',
	'광명',
	'수원',
	'오송',
	'청주',
	'천안',
	'조치원',
	'옥천',
	'천안아산',
	'대전',
	'영동',
	'김천',
	'구미',
	'김천구미',
	'왜관',
	'대구',
	'서대구',
	'동대구',
	'경산',
	'밀양',
	'삼랑진',
	'진영',
	'구포',
	'부산',
	'진영',
	'창원',
	'창원중앙',
	'진주',
	'마산',
];

export default STATIONS;
